module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-duotone-900.3d2ab213.svg";